import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import remoteServices from '~/constants/RemoteServices';
import {rfeCredentialsHeader} from '~/utils/http';

// empty designs api service
export const designsApi = createApi({
  reducerPath: 'designsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${remoteServices.designs}/api`,
    credentials: rfeCredentialsHeader
  }),
  endpoints: () => ({})
});
